module.exports = __webpack_public_path__ + "img/SAP_9060_l.6d5d9e81.jpg";